export const UPDATE_ACCOUNT_NUMBERS = "UPDATE_ACCOUNT_NUMBERS";

export const updateAccountNumbers = payload => ({
  type: UPDATE_ACCOUNT_NUMBERS,
  payload
});
